
import { Vue, Component } from 'vue-property-decorator';
import { List } from 'vant';
import NewsItem from '@/components/News/NewsItem .vue';
import { getNewsList, getBaseInfo } from '../api';
Vue.use(List);
@Component({
  components: {
    NewsItem,
  },
})
export default class News extends Vue {
  list: any[] = [];
  page = 1;
  loading = false;
  finished = false;
  loadingStatus = true;
  refreshing: boolean = false;
  baseInfo: any = {};
  isShow: boolean = true;
  newsType: number = 1;
  async created() {
    this.onLoad();
  }

  changeNewsType(active: number){
    if (this.newsType != active){
      this.newsType = active;
      this.page = 1;
      this.list = [];
      this.isShow = false;
      setTimeout(() => {
        this.isShow = true;
        this.onLoad();
      }, 50);
    }
  }

  goDetail(a: any) {
    const url = a.targetUrl;
    window.location.href = url;
  }
  onLoad() {
    let classId = 2;
    if (this.newsType == 1){
      classId = 2;
    } else if (this.newsType == 2){
      classId = 227;
    } else if (this.newsType == 3){
      classId = 183;
    } else {
      return false;
    }
    const data = {
      page: this.page,
      pageSize: 10,
      columnId: classId,
    };
    getNewsList(data).then((res: any) => {
      this.endListData(res);
    });
  }
  endListData(res: any) {
    this.page = this.page + 1;
    if (res.statusCode !== 200) {
      this.finished = true;
    } else {
      if (!res.data.list || res.data.list.length === 0) {
        this.finished = true;
      } else {
        if (!res.data.list || res.data.list.length === 0) {
          this.finished = true;
        } else {
          this.list = [...this.list, ...res.data.list];
        }
      }
    }
    this.loading = false;
  }
}
